// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html[dir='rtl'] .first-items {
    top: 16%;
}

html[dir='rtl'] .hand-arrow {
    transform: scaleX(-1);
}
@media(min-width:992px) {
    .dimono-logo {
        width: 227px;
        height: 45px;
        margin: auto;

    }

    .dimono-logo img {
        width: 100%;
    }

  
}

@media(min-width: 768px) and (max-width: 991px) {
    .dimono-logo img {
        width: 142px;
    }
}

@media(max-width:767px) {
    .dimono-area {
        margin-bottom: 30px;
        margin-top: 30px;
    }

    .dimono-logo img {
        width: 227px;
    }

    .dimono-application-area-p {
        color: white !important;
    }

}`, "",{"version":3,"sources":["webpack://./src/pages/brands/components/DimonoApplicationArea.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;AACZ;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI;QACI,YAAY;QACZ,YAAY;QACZ,YAAY;;IAEhB;;IAEA;QACI,WAAW;IACf;;;AAGJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,uBAAuB;IAC3B;;AAEJ","sourcesContent":["html[dir='rtl'] .first-items {\n    top: 16%;\n}\n\nhtml[dir='rtl'] .hand-arrow {\n    transform: scaleX(-1);\n}\n@media(min-width:992px) {\n    .dimono-logo {\n        width: 227px;\n        height: 45px;\n        margin: auto;\n\n    }\n\n    .dimono-logo img {\n        width: 100%;\n    }\n\n  \n}\n\n@media(min-width: 768px) and (max-width: 991px) {\n    .dimono-logo img {\n        width: 142px;\n    }\n}\n\n@media(max-width:767px) {\n    .dimono-area {\n        margin-bottom: 30px;\n        margin-top: 30px;\n    }\n\n    .dimono-logo img {\n        width: 227px;\n    }\n\n    .dimono-application-area-p {\n        color: white !important;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
